import { createContext, useContext } from "react"

import type { EAffiliateCampaignType } from "@/modules/helpers/enum"
import type { ValidationErrors } from "@/modules/helpers/utils/campaign-form"
import type { Address } from "@/modules/types"
import type { SaleProp } from "@/modules/types/jobs/affiliate"
import type { AddressInfo } from "@/modules/types/jobs/campaign-form"

export interface ApplyCampaignContextValue {
  productImage: string
  productTitle?: string
  shopName?: string
  addresses: Address[]
  selectedAddress: Address | null
  addressInfo: AddressInfo
  addressEditInfo: AddressInfo
  contentTypes: EAffiliateCampaignType[]
  totalClip: string
  fixedTotalClip?: string
  saleProps: SaleProp[]
  productCampaignSaleProps?: any[]
  saleProp: Record<string, string>
  selectedSkus?: Record<string, Record<string, string>>
  validationErrors: ValidationErrors
  isPending: boolean
  onClose: () => void
  onConfirm: () => void
  onAddressClick: (address: Address | null) => void
  onEditAddress: (address: Address) => void
  onAddNewAddress: () => void
  onToggleContentType: (type: EAffiliateCampaignType) => void
  onTogglePropId: (propId: string, propValueId: string) => void
  onSelectMultiple?: (productId: string, propId: string, propValueId: string) => void
  onUpdateTotalClip: (value: string) => void
  skus?: any[]
  skuHiddens?: any[]
  link?: string
  onRequestSample?: () => Promise<boolean>
  isCheckingSample?: boolean
  isSampleRegistered?: boolean
  hasKolSubmissionId?: boolean

  // Modals & User state
  modals: {
    validateChannel: boolean
    gmvChecking: boolean
    updateAddress: boolean
  }
  showSuccessModal: boolean
  user?: any
  product?: any
  onCloseModal: (modal: "validateChannel" | "gmvChecking" | "updateAddress" | "selectSku") => void
  onCloseSuccessModal: () => void
  onConnectSocialCompleted: () => void
  onGMVCheckingCompleted: () => void
  onAddressModalClose: () => void
  onAddressUpdateCompleted: (info: AddressInfo) => void
}

export const ApplyCampaignContext = createContext<ApplyCampaignContextValue | null>(null)

export function useApplyCampaignContext() {
  const context = useContext(ApplyCampaignContext)
  if (!context) {
    throw new Error("useApplyCampaignContext must be used within ApplyCampaignProvider")
  }
  return context
}
